import React, { useState, useEffect } from 'react'
import Cookies from 'js-cookie'

import { lookupCategory } from '../../global/utilities/lookup-category.js'

import Loader from '../FundDetails/Modules/Shared/Loader.jsx'

import { getSavedFundsCusipList } from './Helpers/getSavedFundsCusipList.js'
import { getMutualFundData } from '../../spa/components/investmentProducts/InvestmentProductsDataSource.js'
import {
  getProductListByCategory,
  flattenFunds,
} from '../FundDetails/Data/FundDetailsDataSource.js'

import SavedWatchList from './SavedWatchList.jsx'
import EditableWatchList from './EditableWatchList.jsx'
import { RETAIL_PRODUCTS } from '../FundDetails/Helpers/FundTypes.js'

export default function FundWatchList() {
  const [isEditing, setIsEditing] = useState(false)
  const [priceAsOfDate, setPriceAsOfDate] = useState('')
  const [savedFunds, setSavedFunds] = useState([])
  const [selectedFunds, setSelectedFunds] = useState([])
  const [fundList, setFundList] = useState([])
  const [funds, setFunds] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const classes = [
    'A',
    'Advisor',
    'C',
    'Institutional',
    'Institutional2',
    'Institutional3',
    'R',
    'V',
  ]

  useEffect(() => {
    setSavedFunds(getSavedFundsCusipList())
  }, [])

  useEffect(() => {
    loadSelectedFunds()
  }, [funds, savedFunds])

  useEffect(() => {
    if (savedFunds.length > 0 && funds.length < 1) {
      initializeData()
    }
  }, [savedFunds])

  useEffect(() => {
    setIsLoading(false)
  }, [fundList])

  useEffect(() => {
    if (isEditing) {
      updateCheckboxes()
    }
  }, [isLoading])

  const onClickEdit = () => {
    setIsEditing(true)

    setIsLoading(true)

    loadFundList()
  }

  const initializeData = async () => {
    setIsLoading(true)

    const _data = await getMutualFundData('PricesAndYields', '')

    const _priceFunds = _data.value.mutualFunds.priceFunds || []

    if (_data.value.mutualFunds.priceAsOfDate) {
      setPriceAsOfDate(_data.value.mutualFunds.priceAsOfDate)
    }

    setFunds(_priceFunds)

    setIsLoading(false)
  }

  const loadSelectedFunds = async () => {
    const _selectedFunds = []

    savedFunds.forEach((cusip) => {
      const _fund = funds && funds.find((fund) => cusip === fund.cusip)

      if (_fund) {
        _selectedFunds.push(_fund)
      }
    })

    setSelectedFunds(_selectedFunds)
  }

  const loadFundList = async () => {
    const _data = await getProductListByCategory(RETAIL_PRODUCTS)

    const _funds = flattenFunds(_data)

    const sortedFunds = _funds.sort((a, b) => {
      if (a && b) {
        return a.fundName.localeCompare(b.fundName)
      } else {
        return 0
      }
    })

    const _fundList = []

    sortedFunds.forEach((fund) => {
      const category = lookupCategory(fund.ctgName)

      const newFund = {
        fundName: fund.fundName,
        filters: fund.filters,
        categoryName: category.name,
        classes: [],
      }

      fund.classes.forEach((info) => {
        if (info.fundClass) {
          const item = {
            cusip: info.cusip,
            symbol: info.symbol,
            class: info.fundClass.replace('Class ', ''),
          }

          newFund.classes.push(item)
        }
      })

      newFund.classes.sort((a, b) => {
        if (a.class && b.class) {
          const aScore = classes.indexOf(a.class)
          const bScore = classes.indexOf(b.class)

          if (aScore > bScore) {
            return 1
          } else if (aScore < bScore) {
            return -1
          } else {
            return 0
          }
        } else {
          return 0
        }
      })

      _fundList.push(newFund)
    })

    setFundList(_fundList)
  }

  const updateCheckboxes = () => {
    const inputList = [...document.querySelectorAll('.class-selection')]

    savedFunds.forEach((cusip) => {
      inputList.forEach((input) => {
        if (cusip === input.value) {
          input.checked = true
        }
      })
    })
  }

  const onClickSave = () => {
    const cusipList = []

    const inputList = document.querySelectorAll('.class-selection:checked')

    inputList.forEach((item) => {
      cusipList.push(item.value)
    })

    Cookies.set('HOMEPAGE_WATCHLIST_FUNDS', cusipList, {
      secure: true,
      expires: 999,
    })

    setSavedFunds(cusipList)

    setIsEditing(false)
  }

  const onClickCancel = () => {
    setIsEditing(false)
  }

  const renderButtons = () => {
    return (
      <div className="Grid">
        <div className="u-size9of12 u-sm-sizeFull u-marginTop3gu">
          <div className="Grid Grid--withGutter">
            <div className="u-sm-size6of12 u-md-size5of12 u-lg-size4of12">
              <button
                className="Button Button--secondary Button--block u-paddingVert2gu"
                onClick={onClickCancel}
              >
                Cancel
              </button>
            </div>
            <div className="u-sm-size6of12 u-md-size5of12 u-lg-size4of12">
              <button
                className="Button Button--primary Button--block cti-submit-email-form-button u-paddingVert2gu"
                onClick={onClickSave}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="Grid u-marginHoriz0 u-paddingLeft3gu u-paddingTop2gu u-posRelative">
      <h2 className="u-size1of2">My Funds</h2>
      {!isLoading &&
        !isEditing &&
        selectedFunds &&
        selectedFunds.length > 0 && (
          <div className="u-size1of2 u-textRight">
            <button
              id="edit-watch-list-link"
              className="Button Button--tertiary Button-editFunds u-marginRight2gu"
              onClick={onClickEdit}
            >
              Edit my fund list
            </button>
          </div>
        )}
      {!isLoading &&
        !isEditing &&
        (!selectedFunds || selectedFunds.length < 1) && (
          <div id="my-funds-message">
            <h3 className="u-marginTop2gu">
              Create a customized list so you can track and watch your funds.
            </h3>
            <button
              className="Button Button--primary u-paddingHoriz8gu u-paddingVert2gu u-textUppercase u-marginTop2gu"
              id="choose-funds"
              onClick={onClickEdit}
            >
              Choose Funds
            </button>

            <p className="u-marginTop3gu">
              NOTE: Your fund selections will be automatically saved for you
              using browser cookies. If you clear your cookies or use a
              different computer or browser to access this page, you will not
              see your saved fund selections.
            </p>
          </div>
        )}
      {!isLoading &&
        !isEditing &&
        selectedFunds &&
        selectedFunds.length > 0 && (
          <SavedWatchList funds={selectedFunds} priceAsOfDate={priceAsOfDate} />
        )}
      {!isLoading && isEditing && (
        <>
          <EditableWatchList funds={fundList} classList={classes} />
          {renderButtons()}
        </>
      )}
      {isLoading && <Loader showBackground={false} />}
    </div>
  )
}
